import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import './ItemList.scss';
import classNames from 'classnames';

const ItemList = (props) => {
  const classes = classNames({
    'nw-itemList': true,
    'nw-itemList--rtl': props.rtl,
  });

  return (
    <div className={classes}>
      { props.data && props.data.map((item, i) => (
        <Item
          key={`item-${i}`}
          label={item.label}
          value={item.value}
          color={item.color}
          code={item.code}
          onClick={() => props.onClick(item)}
        />
      ))}
    </div>
  );
};

ItemList.propTypes = {
  /** array of object for list */
  data: PropTypes.arrayOf(PropTypes.object),
  /** is RTL */
  rtl: PropTypes.bool,
  onClick: PropTypes.func,
};

ItemList.defaultProps = {
  data: [
    {
      id: null,
      label: 'label 1',
      value: 'value 1',
    },
    {
      id: null,
      label: 'label 2',
      value: 'value 2',
    },
  ],
  rtl: false,
  onClick: () => {},
};

export default ItemList;
